import * as React from 'react';
import classnames from 'classnames';
import { useTranslate } from '@insolus/react-i18n';

var _isStringArray = function _isStringArray(node) {
  return Array.isArray(node) && node.every(function (item) {
    return typeof item === 'string';
  });
};

var Empty = function Empty(props) {
  var _useTranslate = useTranslate('ui-kit'),
      __ = _useTranslate.__;

  var children = props.children,
      className = props.className;

  var description = props.description || __('empty.text');

  if (_isStringArray(description)) {
    description = description.join('\n');
  }

  return React.createElement("div", {
    className: classnames(className, 'Empty')
  }, description && React.createElement("p", {
    className: "Empty__description"
  }, description), children && React.createElement("div", {
    className: "Empty__content"
  }, children));
};

Empty.defaultProps = {
  description: undefined,
  className: undefined,
  children: undefined
};
export default Empty;